class Utils {
    static isEmpty(data: any) : boolean {
        if(typeof data === "string"){
            return data !== null && data !== undefined && data.trim().length === 0
        }
        return true;
    }
}

export default Utils